/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import {AccountModel} from "../../models/account-model";

export function accountsGet(http: HttpClient, rootUrl: string, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<AccountModel[]>> {
    const rb = new RequestBuilder(rootUrl, accountsGet.PATH, 'get');

    for (let headerKey of headers.keys()) {
        rb.header(headerKey, headers.get(headerKey));
    }

    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<AccountModel[]>;
        })
    );
}

accountsGet.PATH = '/api/v1/accounts';
